const taipeiClock = new Intl.DateTimeFormat("en-GB", {
  timeZone: "Asia/Taipei",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  weekday: "short",
  hour: "2-digit",
  minute: "2-digit",
  hourCycle: "h23",
});

const WEEKDAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

/**
 * 預設提醒：後端還沒有 /api/pos/reminders（舊版 ciaowin）時使用，
 * 內容與後端 migration 2026_11_05_100000 替宅食光建立的兩則相同（倒垃圾、17:20 烤雞腿）。
 * 欄位同後端 PosReminderService::present()。
 */
export const LEGACY_REMINDERS = [
  {
    reminder_id: "legacy-trash",
    title: "該倒垃圾囉！",
    message: "垃圾車 14:30 離開，記得帶上垃圾",
    remind_time: "14:15",
    weekdays: [1, 2, 4, 5, 6],
    window_minutes: 15,
    button_text: "已倒垃圾",
    icon: "trash",
    position_ids: [2, 3],
  },
  {
    reminder_id: "legacy-chicken",
    title: "烤雞腿製作了嗎？",
    message: "請確認晚餐的烤雞腿是否已開始製作",
    remind_time: "17:20",
    weekdays: [0, 1, 2, 3, 4, 5, 6],
    window_minutes: 30,
    button_text: "已製作",
    icon: "food",
    position_ids: [2, 3],
  },
];

function toMinutes(time) {
  const match = /^(\d{2}):(\d{2})$/.exec(String(time || ""));
  if (!match) return null;
  return Number(match[1]) * 60 + Number(match[2]);
}

/**
 * 某一則提醒在 now（以台灣時間判斷）的狀態：
 * - 不是提醒日、還沒到或已過提醒期間 → null
 * - 提醒期間內 → { day, shouldStart }，只有提醒時間那一分鐘 shouldStart 為 true（不補提醒）
 */
export function getReminderSchedule(reminder, now = new Date()) {
  const start = toMinutes(reminder?.remind_time);
  const windowMinutes = Number(reminder?.window_minutes) || 0;
  if (start === null || windowMinutes <= 0) return null;

  const parts = Object.fromEntries(
    taipeiClock.formatToParts(now).map(({ type, value }) => [type, value])
  );
  const weekdays = (reminder.weekdays || []).map(Number);
  const minutes = Number(parts.hour) * 60 + Number(parts.minute);
  if (!weekdays.includes(WEEKDAY_INDEX[parts.weekday]) || minutes < start || minutes >= start + windowMinutes) {
    return null;
  }
  return {
    day: `${parts.year}-${parts.month}-${parts.day}`,
    shouldStart: minutes === start,
  };
}
